
export const state = () => ({
  urlGeneralSetting: '/api/sm/manager/config',
  urlGuiCert: 'api/sm/manager/certification',
  urlAuthProfile: 'api/sm/auth/profiles',
  generalSettingData: {
    gui_idle_exit: 1, //        required (one of 0, 1) 유휴 상태 설정 사용(OFF: 0, ON: 1)
    gui_idle_use: 1, //         required (one of 0, 1) 유휴 상태시 GUI 종료 사용(OFF: 0, ON: 1)
    login_fail_cnt: 3, //       required (integer - default: 3 - minimum: 3 - maximum: 10) 로그인 최대 실패 횟수
    gui_idle_tm: 1, //          required (integer - default: 30 - minimum: 1 - maximum: 30) 최대 유휴 시간(분)
    cli_port: 22, //            required (integer - default: 22 - minimum: 1 - maximum: 65535) CLI 접속 포트
    gui_port: 443, //           required (integer - default: 443 - minimum: 1 - maximum: 65535) GUI 접속 포트
    ext_auth_use: 0, //         외부 인증 프로파일 사용 여부
    auth_prof: {
      auth_prof_id: '' //            required (string) 인증 프로파일 ID
    }
  },
  guiCertData: {
    signature_alg: '', // required (string) 서명 알고리즘
    issuer: '', //        required (string) 발급자
    not_before: '', //    required (string) 유효 기간(시작)
    not_after: '', //     required (string) 유효 기간(끝)
    subject: '', //       required (string) 주제
    public_alg: '' //     required (string) 공개키 알고리즘
  }
})

export const mutations = {
  getGeneralSettingData: (state, item) => {
    if (item.auth_prof === null) {
      item.ext_auth_use = 0
      item.auth_prof = {}
      item.auth_prof.auth_prof_id = ''
    } else {
      item.ext_auth_use = 1
    }
    state.generalSettingData = item
  },
  getGuiCertData: (state, item) => {
    state.guiCertData = item
  }
}

export const actions = {
  async getGeneralSettingData ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlGeneralSetting)
    if (code === 'ok') {
      commit('getGeneralSettingData', result)
      return true
    }
    return false
  },
  async setGeneralSettingData ({commit, state}) {
    const param = _.cloneDeep(state.generalSettingData)
    if (param.ext_auth_use === 0) {
      param.auth_prof = null
    }
    const {code, result} = await this.$axios.$put(state.urlGeneralSetting, param, {loadingHide: false, successAlert: false})
    if (code === 'ok') {
      commit('getGeneralSettingData', result)
      return true
    }
    return false
  },
  // apply / cancel 분리 필요 cancel 인 경우 reload 해야 함
  async finalCommand ({commit, state}, param) {
    const {code} = await this.$axios.$put(`${state.urlGeneralSetting}/${param.type}`, null, param.option)
    if (code === 'ok') {
      return true
    }
    return false
  },
  async getGuiCertData ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlGuiCert)
    if (code === 'ok') {
      commit('getGuiCertData', result)
      return true
    }
    return false
  },
  async issueGuiCert ({commit, state}, ip) {
    const {code, result} = await this.$axios.$post(state.urlGuiCert, {ip: ip})
    if (code === 'ok') {
      commit('getGuiCertData', result)
      return true
    }
    return false
  },
  async getProfileDataList ({state}) {
    const data = await this.$axios.$get(state.urlAuthProfile, {params: {auth_only: 1}})
    return data
  }
}

export const getters = {
  validateAuthProfile (state) {
    // 프로파일 사용으로 되어 있으나 프로파일이 선택되어 있지 않는 경우 에러 처리
    try {
      if (state.generalSettingData.ext_auth_use === 1 && (state.generalSettingData.auth_prof.auth_prof_id === '')) {
        return false
      }
      return true
    } catch (e) {
      return false
    }
  }
}

export const strict = false
